import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import ContentListing from "../../../components/ContentListing/component";
import RegionInfo from "../../../components/RegionInfo/component";
import Ad from "../../../components/Ad/component";
import { parseContentListingItems } from "../../../utils/dataTransform";
import { DATA_URL, MULTI_LINEUP_NEWS } from "./constants";
import { fetchMultipleLineups } from "../../../fetch/graphql/requests/lineups";

import ContentArea from "../../../components/ContentArea/async.component";
import log from "../../../utils/logger/library";
import { SectionHeading } from "../../../components/Heading/component";
import VideoPlaylist from "../../../components/LayoutFactory/layouts/VideoPlaylist/component";
import { extractDataFromStateBasedOnStorePath } from "../../../utils/store/library";

async function getMultipleLineups(setNewsSectionListings) {
    try {
        const sections = await fetchMultipleLineups(MULTI_LINEUP_NEWS, 4);
        const preparedSections = parseContentListingItems(
            MULTI_LINEUP_NEWS,
            sections
        );
        setNewsSectionListings([...preparedSections]);
    } catch (error) {
        log.error(
            `(getMultipleLineups) ContentListing rendering (${DATA_URL}) failed`,
            error
        );
    }
}

/**
 * Return the NewsLanding Main Template
 *
 * @param {string} viewport the current browser viewport
 * @param {object} splitProps the props required for the page ContentArea components
 */
const Main = ({ viewport, splitProps }) => {
    const [newsSectionListings, setNewsSectionListings] = useState([]);
    const contentListingProps = {
        title: "News Sections",
        contentList: newsSectionListings,
        viewport: viewport,
        rightRailStyling: true,
    };

    useEffect(() => {
        getMultipleLineups(setNewsSectionListings);
    }, []);

    const playlistData = useSelector((state) =>
        extractDataFromStateBasedOnStorePath(state, "video.curatedPlaylist")
    );

    const renderVideoPlaylist = () => {
        if (!splitProps.moreContentProps.renderCuratedPlaylist) {
            return null;
        }

        const playlistItems = playlistData?.items
            ? playlistData.items.filter((item) => item)
            : [];

        const playlistLayoutProps = {
            playlistTitle: "Featured Video",
        };

        const featureAttributionData = {
            instance: "News",
        };

        return (
            <div className="playlistSwimlane">
                <SectionHeading text="Featured Video" />
                <VideoPlaylist
                    layout={playlistLayoutProps}
                    items={playlistItems}
                    featureAttributionData={featureAttributionData}
                />
            </div>
        );
    };

    return (
        <div className="landingNewsSplit" data-testid="landing-news-split">
            <ContentArea {...splitProps.featuredProps} />
            <RegionInfo isSwimlane={true} />
            {renderVideoPlaylist()}
            <Ad type="intercept" lazy={true} targeting={{ plc: "feed" }} />
            <ContentListing {...contentListingProps} />
            <SectionHeading text="More CBC News" />
            <ContentArea {...splitProps.moreContentProps} />
        </div>
    );
};

Main.propTypes = {
    viewport: PropTypes.string,
    splitProps: PropTypes.object,
};

export default Main;
